// extracted by mini-css-extract-plugin
export default {"watermarkBanner":"Dsiie9XktNMntKKgmbxC","watermarkBannerSvg":"o_dAfpdoAAZD2i4nuY_F","watermarkBannerDescription":"e72QOD4XB3UdBJl5dPNc"};